const addScrollEventListener = require('../helpers/addscrolleventlistener');
const events = require('../core/events');

function SnapScroll(rootElement, contentViewElement, options) {
  var self = this;

  // Runtime vars
  // TODO: Babel + ES6 classes would be worthwhile here
  var root = rootElement;
  var contentView = contentViewElement;
  var scrollStartPosition = 0;
  var clientWidth = 0;
  var scrollWidth = 0;
  var itemWidth = 0;
  var offsetDistance = 0;
  var resetTimeout = null;
  var isScrolling = false;
  var isResetting = false;

  // TODO: Options object parser would be good here
  this.config = {
    scrollTriggerAt: options.scrollTriggerAt || 0.2,
    scrollLockTime: options.scrollingTimeout || 300,
    clipWidth: options.clipWidth || undefined,
    offsetDistance: options.offsetDistance || 0,
    scrollingLockClass: options.scrollingLockClass || 'is-scrolling'
  };

  function startScroll() {
    if (!isScrolling) {
      // Refresh dimensions once, at start of scroll gesture.
      refreshDimensions();
    }

    isScrolling = true;

    window.clearTimeout(resetTimeout);
    resetTimeout = window.setTimeout(function () {
      isScrolling = false;
      endScroll();
    }, 64); // 64ms ~~ 4 frames
  }

  function endScroll() {
    /* Resolves slide position & snaps to grid */
    snapToPage();
  }

  function refreshDimensions() {
    requestAnimationFrame(function () {
      // get dimensions
      clientWidth = contentView.clientWidth;
      scrollWidth = contentView.scrollWidth;
      itemWidth = self.config.clipWidth || contentView.firstElementChild.offsetWidth;
      offsetDistance = self.config.offsetDistance || 0;

      // update start position
      scrollStartPosition = root.scrollLeft;
    });
  }

  function turnPage(direction) {
    refreshDimensions();
    requestAnimationFrame(function () {
      const currentScrollPos = root.scrollLeft;
      const newPosition = (function () {
        switch (direction) {
          case SnapScroll.FORWARDS: return currentScrollPos + itemWidth;
          case SnapScroll.BACKWARDS: return currentScrollPos - itemWidth;
          default: return currentScrollPos;
        }
      }());
      resetScroll(newPosition);
    });
  }

  function goToPage(index) {
    refreshDimensions();

    requestAnimationFrame(function () {
      const newPosition = index * itemWidth;
      resetScroll(newPosition);
    });
  }

  function resetScroll(newPosition) {
    if (isResetting) { return; }

    isResetting = true;
    clearTimeout(resetTimeout);

    const maxPosition = scrollWidth - clientWidth;
    const misalignment = newPosition % itemWidth;
    const adjustment = misalignment > itemWidth * 0.5 ? (itemWidth - misalignment) : -misalignment;
    const roundedPosition = newPosition + adjustment;
    const offsetPosition = roundedPosition - offsetDistance;

    // If we scroll to the end at an imperfect width, don't jump backwards:
    // >= to handle elastic scrolling
    if (newPosition >= maxPosition) {
      animateScrollTo(maxPosition);
    } else {
      animateScrollTo(Math.max(0, Math.min(offsetPosition, maxPosition)));
    }
  }

  function animateScrollTo(newPosition) {
    requestAnimationFrame(function () {
      var fromPosition = root.scrollLeft;

      if (fromPosition === newPosition) {
        isResetting = false;
        isScrolling = false;
        return;
      }

      root.classList.add(self.config.scrollingLockClass);
      contentView.style.transform = ['translate(', fromPosition - newPosition, 'px, 0)'].join('');
      root.dispatchEvent(new CustomEvent(events.uiScrollSnap, {
        bubbles: true,
        detail: {
          scrollLeft: newPosition,
          pageIndex: Math.floor(newPosition / itemWidth)
        }
      }));

      setTimeout(function () {
        replaceNativeScrolling(newPosition);
      }, self.config.scrollLockTime);
    });
  }

  function replaceNativeScrolling(position) {
    requestAnimationFrame(function () {
      root.classList.remove(self.config.scrollingLockClass);
      contentView.style.transform = 'none';
      root.scrollLeft = position;

      isResetting = false;
      isScrolling = false;
    });
  }

  /**
   * After a natural scroll interaction, snap the scrollview back to alignment. This function
   * first determines whether to advance the slide forward based on the scroll trigger option,
   * then turns the page as appropriate.
   */
  function snapToPage() {
    const roundingAdjustment = 0.5 - self.config.scrollTriggerAt;

    requestAnimationFrame(function () {
      const currentScrollPos = root.scrollLeft;
      const scrollDifference = scrollStartPosition - currentScrollPos;
      const forward = scrollDifference < 0;
      const scrollPerItem = scrollDifference / itemWidth;
      const percentageScrolled = forward ? 1 - (1 + scrollPerItem) : scrollPerItem;

      // Trigger movement if we've moved enough of the view:
      // If we've scrolled greater than 50%, we already revealled the next slide and we
      // will snap to it without specifying advancement.
      const shouldAdvance = percentageScrolled < 0.5 && percentageScrolled + roundingAdjustment > 0.5;

      if (shouldAdvance) {
        turnPage(forward ? SnapScroll.FORWARDS : SnapScroll.BACKWARDS);
      } else {
        turnPage(/* current page */);
      }
    });
  }

  // BUG: This gets events from interial scrolling too, hence the delay in
  // reactivating scrolling after reset. Maybe try to detect and estimate that
  // in future.
  addScrollEventListener(root, function (/* scrollEvent */) {
    startScroll();
  });

  this.turnPage = turnPage;
  this.goToPage = goToPage;
}

SnapScroll.FORWARDS = 'F';
SnapScroll.BACKWARDS = 'B';

module.exports = SnapScroll;



//////////////////
// WEBPACK FOOTER
// ./src/js/mixins/snapscroll.js
// module id = 35
// module chunks = 0